import { configureStore } from '@reduxjs/toolkit';
import product from './reducers/products';
import frames from './reducers/frames';
import order from './reducers/orders';
import settings from './reducers/settings';
import search from './reducers/search';
import ui from './reducers/ui';

const store = configureStore({
  reducer: {
    order,
    frames,
    product,
    settings,
    search,
    ui,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    serializableCheck: false,
  }),
  devTools: process.env.NODE_ENV !== 'production',
});

export default store;
